import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openPersonalizationSubmenu } from '../sidebarHelpers';

const turnOnSubscriptionBanner = (baseUrl, navigate, currentDomain, user) => {
  return {
    id: 'turnOnSubscriptionBanner',
    title: 'Turn on the subscription banner',
    steps: [
      {
        selector: '[data-tour="webPersonalizationLink"]',
        content: <p>Click on the "Personalization" menu item in the navigation.</p>,
      },
      {
        actionBefore: async () => {
          navigate(`${baseUrl}/pages?type=bannerBlocks`, true);
          await openPersonalizationSubmenu('[data-tour="bannerBlocksLink"]');
        },
        selector: '[data-tour="bannerBlocksLink"]',
        content: <p>Click on the "Banner Blocks" in the navigation</p>,
      },
      {
        actionBefore: () => closeSidebarPanel(),
        selector: '[data-tour="bannerBlocksName=Subscription form"]',
        content: <p>This is the Subscription banner.</p>,
      },
      {
        selector: '[data-tour="bannerBlocksName=Subscription form"] [data-tour="bannerBlockRunBtn"]',
        content: <p>Click here to turn it on and allow your visitors to see it.</p>,
      },
      {
        selector: '[data-tour="bannerBlocksName=Subscription form"]',
        content: (
          <>
            <p>The banner is turned on now you can check if it is active.</p>
            <a href={`${currentDomain.url}/`} target="_blank" rel="noopener noreferrer">
              Click here to check.
            </a>
          </>
        ),
        actionBefore: () =>
          document
            .querySelector(
              '[data-tour="bannerBlocksName=Subscription form"] [data-tour="bannerBlockRunBtn"] .mantine-Switch-body'
            )
            ?.click(),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find(
      (a) => a.action === 'taskCompleted' && a.context.task === 'turnOnSubscriptionBanner'
    ),
  };
};

export default turnOnSubscriptionBanner;
